// /*
// * Broadcast Theme
// *
// * Use this file to add custom Javascript to Broadcast.  Keeping your custom
// * Javascript in this fill will make it easier to update Broadcast. In order
// * to use this file you will need to open layout/theme.liquid and uncomment
// * the custom.js script import line near the bottom of the file.
// */

// (function () {
//   console.log("%cStarter Pack Cleaner Loaded (Dynamic Box Logic, NO FITMENT)", "color: green; font-weight: bold;");

//   // ----------------------------------------------------------------------
//   // IDs (Replace ONLY if your variants change)
//   // ----------------------------------------------------------------------
//   const BOX_ID = 52648915239246;

//   const CASE_IDS = [
//     51074268365134,
//     51074268332366,
//     51074268397902
//   ];

//   const REFILL_IDS = [
//     51074269249870,
//     51074269217102,
//     51074269184334,
//     51074269282638
//   ];

//   // ----------------------------------------------------------------------
//   // Detect Case
//   // ----------------------------------------------------------------------
//   function isCase(item) {
//     return CASE_IDS.includes(item.variant_id);
//   }

//   // ----------------------------------------------------------------------
//   // Detect Refill
//   // ----------------------------------------------------------------------
//   function isRefill(item) {
//     return REFILL_IDS.includes(item.variant_id);
//   }

//   // ----------------------------------------------------------------------
//   // MAIN LOGIC — Dynamic Box Handling
//   // ----------------------------------------------------------------------
//   async function checkAndRemoveBox() {
//     try {
//       const cart = await fetch("/cart.js").then(r => r.json());

//       let caseCount = 0;
//       let refillCount = 0;
//       let boxLine = null;
//       let currentBoxQty = 0;

//       // Scan cart items
//       cart.items.forEach((item, index) => {
//         if (isCase(item)) caseCount += item.quantity;
//         if (isRefill(item)) refillCount += item.quantity;

//         if (item.variant_id === BOX_ID) {
//           boxLine = index + 1;
//           currentBoxQty = item.quantity;
//         }
//       });

//       // REQUIRED BOXES = min(caseCount, refillCount)
//       const requiredBoxQty = Math.min(caseCount, refillCount);

//       console.log("[Cleaner Debug] Case:", caseCount, "Refill:", refillCount, "RequiredBoxQty:", requiredBoxQty);

//       // ------------------------------------------------------------------
//       // CASE 1: No boxes required → remove box entirely
//       // ------------------------------------------------------------------
//       if (requiredBoxQty === 0) {
//         if (boxLine) {
//           console.log("[Cleaner] Removing all storage boxes...");
//           await fetch("/cart/change.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ line: boxLine, quantity: 0 })
//           });
//         }
//         return;
//       }

//       // ------------------------------------------------------------------
//       // CASE 2: Box exists but incorrect quantity → adjust it
//       // ------------------------------------------------------------------
//       if (boxLine) {
//         if (currentBoxQty !== requiredBoxQty) {
//           console.log("[Cleaner] Adjusting storage box qty to:", requiredBoxQty);
//           await fetch("/cart/change.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               line: boxLine,
//               quantity: requiredBoxQty
//             })
//           });
//         }
//         return;
//       }

//       // ------------------------------------------------------------------
//       // CASE 3: No box exists but required > 0 → add box(es)
//       // ------------------------------------------------------------------
//       console.log("[Cleaner] Adding storage boxes:", requiredBoxQty);
//       // await fetch("/cart/add.js", {
//       //   method: "POST",
//       //   headers: { "Content-Type": "application/json" },
//       //   body: JSON.stringify({
//       //     id: BOX_ID,
//       //     quantity: requiredBoxQty
//       //   })
//       // });

//     } catch (err) {
//       console.error("[Cleaner] ERROR:", err);
//     }
//   }

//   // ----------------------------------------------------------------------
//   // 1. Intercept Shopify fetch() cart API calls
//   // ----------------------------------------------------------------------
//   const originalFetch = window.fetch;
//   window.fetch = async function (input, init) {
//     const url = typeof input === "string" ? input : input?.url;
//     const response = await originalFetch.apply(this, arguments);

//     if (url && (
//       url.includes("/cart/add") ||
//       url.includes("/cart/change") ||
//       url.includes("/cart/update") ||
//       url.includes("/cart/clear")
//     )) {
//       console.log("[Cleaner] FETCH cart update detected:", url);
//       setTimeout(checkAndRemoveBox, 300);
//     }

//     return response;
//   };

//   // ----------------------------------------------------------------------
//   // 2. Intercept XHR cart calls (older themes/apps)
//   // ----------------------------------------------------------------------
//   const OldXHR = XMLHttpRequest;
//   XMLHttpRequest = function () {
//     const xhr = new OldXHR();
//     const open = xhr.open;

//     xhr.open = function () {
//       this._url = arguments[1];
//       return open.apply(this, arguments);
//     };

//     xhr.addEventListener("load", function () {
//       const url = this._url || "";

//       if (
//         url.includes("/cart/add") ||
//         url.includes("/cart/change") ||
//         url.includes("/cart/update") ||
//         url.includes("/cart/clear")
//       ) {
//         console.log("[Cleaner] XHR cart update detected:", url);
//         setTimeout(checkAndRemoveBox, 300);
//       }
//     });

//     return xhr;
//   };
//   XMLHttpRequest.prototype = OldXHR.prototype;

//   // ----------------------------------------------------------------------
//   // 3. MutationObserver fallback (DOM change detection)
//   // ----------------------------------------------------------------------
//   const observer = new MutationObserver((mutations) => {
//     const changed = mutations.some(m => m.type === "childList");
//     if (changed) {
//       console.log("[Cleaner] DOM change → re-checking cart");
//       setTimeout(checkAndRemoveBox, 400);
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

// })();












// document.addEventListener("DOMContentLoaded", () => {

//   if (!window.location.pathname.includes('/products/natural-deodorant') || window.location.search.includes("selection=refills")) return;

//   /* ---------------------------
//      VARIANT → SLIDE MAPPINGS (DEFAULT)
//   ----------------------------*/
//   const mappingDefault = {
//     "51074269184334": 6,
//     "51074269217102": 7,
//     "51074269249870": 8,
//     "51074269282638": 9
//   };

//   function getActiveMap() {
//     return mappingDefault;
//   }

//   /* ---------------------------
//      THUMBNAIL FINDER (STABLE)
//   ----------------------------*/
//   function getThumbs() {
//     const list = document.querySelectorAll(
//       ".product__thumb a, .product__thumb__link, a.product_thumb, .product-thumb a, .product-thumbs a"
//     );
//     return Array.from(list).filter(el => el.offsetParent !== null);
//   }

//   /* ---------------------------
//      SAFE CLICK FUNCTION
//   ----------------------------*/
//   function safeClick(el) {
//     if (!el) return;
//     const a = el.closest("a") || el.querySelector("a") || el;
//     setTimeout(() => a.click(), 10);
//   }

//   /* ---------------------------
//      ADD BUTTON HANDLER
//   ----------------------------*/
//   document.body.addEventListener("click", e => {
//     const btn = e.target.closest(".big-plus, .add, button.add");
//     if (!btn) return;

//     const map = getActiveMap();

//     const row =
//       btn.closest("[data-variant-id]") ||
//       btn.closest("[data-variant-id-row]") ||
//       btn.closest("[data-variant]");

//     if (!row) return;

//     const variantId =
//       row.getAttribute("data-variant-id") ||
//       row.getAttribute("data-variant");

//     const slideIndex = map[variantId];
//     if (!slideIndex) return;

//     requestAnimationFrame(() => {
//       const thumbs = getThumbs();
//       safeClick(thumbs[slideIndex - 1]);
//     });
//   });

//   /* ---------------------------
//      QUANTITY WATCH (PERFECT)
//   ----------------------------*/
//   function watchQuantity(row) {
//     const input = row.querySelector(".quantity-input");
//     if (!input) return;

//     let last = input.value;

//     const observer = new MutationObserver(() => {
//       const value = parseInt(input.value, 10);
//       if (value === 0 && last !== "0") {
//         const thumbs = getThumbs();
//         safeClick(thumbs[0]); // ALWAYS show first image
//       }
//       last = value;
//     });

//     observer.observe(input, { attributes: true, childList: true, characterData: true });
//   }

//   /* ---------------------------
//      MINUS BUTTON HANDLER
//   ----------------------------*/
//   document.body.addEventListener("click", e => {
//     const btn = e.target.closest(".minus-btn, .minus, .minus-button, .quantity__minus");
//     if (!btn) return;

//     const row =
//       btn.closest("[data-variant-id]") ||
//       btn.closest("[data-variant-id-row]") ||
//       btn.closest("[data-variant]");

//     if (!row) return;

//     // ensure we are watching this row
//     watchQuantity(row);

//     // slight delay to allow Shopify to update qty
//     setTimeout(() => {
//       const input = row.querySelector(".quantity-input");
//       if (input && parseInt(input.value, 10) === 0) {
//         const thumbs = getThumbs();
//         safeClick(thumbs[0]);
//       }
//     }, 80);
//   });

// });

// document.addEventListener("DOMContentLoaded", () => {

//   if (!window.location.pathname.includes('/products/natural-deodorant') || !window.location.search.includes("selection=refills")) return;
//   const mappingRefills = {
//     "51074269184334": 1,
//     "51074269217102": 2,
//     "51074269249870": 3,
//     "51074269282638": 4
//   };
//   function getActiveMap() {
//     return mappingRefills;
//   }
//   function getThumbs() {
//     const list = document.querySelectorAll(
//       ".product__thumb a, .product__thumb__link, a.product_thumb, .product-thumb a, .product-thumbs a"
//     );
//     return Array.from(list).filter(el => el.offsetParent !== null);
//   }
//   function safeClick(el) {
//     if (!el) return;
//     const a = el.closest("a") || el.querySelector("a") || el;
//     setTimeout(() => a.click(), 10);
//   }
//   document.body.addEventListener("click", e => {
//     const btn = e.target.closest(".big-plus, .add, button.add");
//     if (!btn) return;
//     const map = getActiveMap();
//     const row =
//       btn.closest("[data-variant-id]") ||
//       btn.closest("[data-variant-id-row]") ||
//       btn.closest("[data-variant]");
//     if (!row) return;
//     const variantId =
//       row.getAttribute("data-variant-id") ||
//       row.getAttribute("data-variant");
//     const slideIndex = map[variantId];
//     if (!slideIndex) return;
//     requestAnimationFrame(() => {
//       const thumbs = getThumbs();
//       safeClick(thumbs[slideIndex - 1]);
//     });
//   });
//   function watchQuantity(row) {
//     const input = row.querySelector(".quantity-input");
//     if (!input) return;
//     let last = input.value;
//     const observer = new MutationObserver(() => {
//       const value = parseInt(input.value, 10);
//       if (value === 0 && last !== "0") {
//         const thumbs = getThumbs();
//         safeClick(thumbs[0]); 
//       }
//       last = value;
//     });
//     observer.observe(input, { attributes: true, childList: true, characterData: true });
//   }
//   document.body.addEventListener("click", e => {
//     const btn = e.target.closest(".minus-btn, .minus, .minus-button, .quantity__minus");
//     if (!btn) return;
//     const row =
//       btn.closest("[data-variant-id]") ||
//       btn.closest("[data-variant-id-row]") ||
//       btn.closest("[data-variant]");
//     if (!row) return;
//     watchQuantity(row);
//     setTimeout(() => {
//       const input = row.querySelector(".quantity-input");
//       if (input && parseInt(input.value, 10) === 0) {
//         const thumbs = getThumbs();
//         safeClick(thumbs[0]);
//       }
//     }, 80);
//   });

// });


// (async function(){
//   console.clear();
//   console.log('thumbnail-cleaner: loader');
//   function isRefillUrl() {
//     try {
//       return new URL(location.href).searchParams.get('selection') === 'refills';
//     } catch(e) { return false; }
//   }
//   async function runCleanerOnce() {
//     if (!isRefillUrl()) {
//       console.log('thumbnail-cleaner: selection=refills not present — skipping run.');
//       return;
//     }
//     console.log('thumbnail-cleaner: selection=refills detected — running cleaner...');
//     const positionsToRemove = [1,2,4,5];
//     const autoPatterns = []; 
//     const containerSelectors = [
//       '.product_thumbs',
//       '.product-thumbs',
//       '.product__thumbs',
//       '.product-thumbs__list',
//       '.thumbnails',
//       '[data-product-thumbs]',
//       '.product__media-list',
//       '.product__thumbs-holder',
//       '.media--thumbnails',
//       'product-thumbs',
//     ];
//     const childSelectors = ['.product_thumb', '.product-thumb', 'li', 'a', ':scope > *'];
//     function waitForContainer(timeout = 12000) {
//       return new Promise(resolve=>{
//         const start = Date.now();
//         (function poll(){
//           for (const s of containerSelectors) {
//             const el = document.querySelector(s);
//             if (el) return resolve({selector: s, element: el});
//           }
//           const imgsCandidates = Array.from(document.querySelectorAll('main img, .product img, .product__media img'));
//           if (imgsCandidates.length >= 3) {
//             for (const img of imgsCandidates) {
//               const parent = img.closest('div,section,ul');
//               if (parent && parent.querySelectorAll('img').length >= 3) {
//                 return resolve({selector: 'auto-detected', element: parent});
//               }
//             }
//           }
//           if (Date.now() - start > timeout) return resolve(null);
//           setTimeout(poll, 200);
//         })();
//       });
//     }
//     function findChildSelector(container) {
//       for (const s of childSelectors) {
//         try {
//           const found = container.querySelectorAll(s);
//           if (found && found.length) return s;
//         } catch(e){}
//       }
//       return ':scope > *';
//     }
//     function describeThumb(node){
//       const info = {};
//       Array.from(node.attributes || []).forEach(a=>{
//         if (a && a.name && a.value) info[a.name] = a.value;
//       });
//       const a = node.querySelector('a') || node.closest('a');
//       const img = node.querySelector('img') || (a && a.querySelector('img'));
//       info.href = a && a.getAttribute ? a.getAttribute('href') : null;
//       info.src = img && img.getAttribute ? img.getAttribute('src') : null;
//       info.snippet = (node.outerHTML || String(node)).replace(/\s+/g,' ').slice(0,260);
//       return info;
//     }
//     function removeNode(node) {
//       try {
//         const parent = node.parentElement;
//         node.remove();
//         if (parent && parent.children.length === 0 && parent.className && parent.className.indexOf('thumb') !== -1) {
//           parent.remove();
//         }
//         return true;
//       } catch(e){
//         console.warn('thumbnail-cleaner: removeNode error', e);
//         return false;
//       }
//     }
//     function pruneEmptyPlaceholders(container) {
//       const children = Array.from(container.children || []);
//       children.forEach(ch=>{
//         const rect = ch.getBoundingClientRect();
//         const text = (ch.textContent||'').trim();
//         if ((rect.width === 0 && rect.height === 0) || (!ch.querySelector('img') && text.length < 2 && (rect.width < 20 || rect.height < 20))) {
//           try { ch.remove(); console.log('thumbnail-cleaner: removed placeholder child', ch); } catch(e){}
//         }
//       });
//     }
//     function refreshLayout() {
//       try {
//         window.dispatchEvent(new Event('resize'));
//         document.dispatchEvent(new CustomEvent('thumbnail-cleaner:changed'));
//         if (typeof window.Slideshow !== 'undefined' && typeof window.Slideshow.reinit === 'function') {
//           try { window.Slideshow.reinit(); console.log('thumbnail-cleaner: called window.Slideshow.reinit'); } catch(e){}
//         }
//         if (window.jQuery) {
//           try { jQuery(window).trigger('resize'); } catch(e){}
//         }
//       } catch(e){ console.warn('thumbnail-cleaner: refreshLayout error', e); }
//     }
//     const containerInfo = await waitForContainer(12000);
//     if (!containerInfo) {
//       console.error('thumbnail-cleaner: could not find thumbnails container on page.');
//       return;
//     }
//     const container = containerInfo.element;
//     console.log('thumbnail-cleaner: container found ->', containerInfo.selector, container);
//     const childSel = findChildSelector(container);
//     console.log('thumbnail-cleaner: child selector chosen ->', childSel);
//     const thumbs = Array.from(container.querySelectorAll(childSel));
//     const nodes = (thumbs.length ? thumbs : Array.from(container.children || []));
//     console.log('thumbnail-cleaner: found', nodes.length, 'candidate nodes');
//     let removedAnything = false;
//     positionsToRemove.slice().sort((a,b)=>b-a).forEach(pos=>{
//       const idx = pos - 1;
//       if (idx >=0 && idx < nodes.length) {
//         const n = nodes[idx];
//         if (n) {
//           removeNode(n);
//           console.log('thumbnail-cleaner: removed by position', pos);
//           removedAnything = true;
//         }
//       } else {
//         console.log('thumbnail-cleaner: position out of range', pos);
//       }
//     });
//     if (autoPatterns && autoPatterns.length) {
//       const re = new RegExp(autoPatterns.map(p=>p.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')).join('|'), 'i');
//       const current = Array.from(container.querySelectorAll(childSel)).concat(Array.from(container.children||[]));
//       current.forEach((n,i)=>{
//         const d = describeThumb(n);
//         const hay = (d.href||'') + '|' + (d.src||'') + '|' + JSON.stringify(d);
//         if (re.test(hay)) {
//           removeNode(n);
//           console.log('thumbnail-cleaner: removed by pattern match', n, d);
//           removedAnything = true;
//         }
//       });
//     }
//     pruneEmptyPlaceholders(container);
//     try {
//       container.style.gap = '0';
//       container.style.margin = '0';
//       container.style.padding = '0';
//       container.style.display = container.style.display || 'flex';
//       container.style.alignItems = 'flex-start';
//       Array.from(container.children || []).forEach(ch=>{
//         try {
//           ch.style.margin = '0';
//           ch.style.padding = '0';
//           ch.style.minHeight = '0';
//           ch.style.minWidth = '0';
//         } catch(e){}
//       });
//     } catch(e){ console.warn('thumbnail-cleaner: style adjust error', e); }

//     refreshLayout();
//     const remaining = Array.from(container.querySelectorAll(childSel)).concat(Array.from(container.children||[]));
//     console.log('thumbnail-cleaner: finished. removedAnything=', removedAnything, '. remaining nodes count=', remaining.length);
//     remaining.forEach((n,i)=> {
//       const d = describeThumb(n);
//       console.log(`remaining index=${i+1}`, d);
//     });
//     if (!removedAnything) {
//       console.warn('thumbnail-cleaner: nothing removed. Copy one of the "index=..." logs above (the snippet/href/src) and paste here so I can provide an exact matcher.');
//     } else {
//       console.log('thumbnail-cleaner: done.');
//     }
//   }
//   if (isRefillUrl()) {
//     runCleanerOnce();
//   } else {
//     console.log('thumbnail-cleaner: selection=refills not present at load - waiting for URL change...');
//   }
//   let lastHref = location.href;
//   const hrefCheckInterval = setInterval(() => {
//     if (location.href !== lastHref) {
//       lastHref = location.href;
//       console.log('thumbnail-cleaner: detected URL change ->', lastHref);
//       if (isRefillUrl()) {
//         runCleanerOnce();
//       }
//     }
//   }, 400);
// })();











// // free gift upsell hide form refill products
// (function () {
//   function hideUpsellForRefills() {
//     if (!window.location.search.includes('selection=refills')) return;
//     document.querySelectorAll('.product__block.upsell-products').forEach(block => {
//       block.style.display = 'none';
//     });
//   }
//   hideUpsellForRefills();
//   const observer = new MutationObserver(() => {
//     hideUpsellForRefills();
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// })();















// (function () {
//   function isRefillPage() {
//     return window.location.pathname.includes('/products/natural-deodorant') &&
//            window.location.search.includes('selection=refills');
//   }

//   if (!isRefillPage()) return;

//   function hideLastThree() {
//     const thumbs = document.querySelectorAll('.product__thumb');

//     if (thumbs.length >= 3) {
//       const lastThree = Array.from(thumbs).slice(-3);
//       lastThree.forEach(el => {
//         el.style.display = 'none';
//       });
//     }
//   }

//   // Run multiple times (Shopify loads async)
//   const runWithDelay = () => {
//     hideLastThree();
//     setTimeout(hideLastThree, 300);
//     setTimeout(hideLastThree, 800);
//     setTimeout(hideLastThree, 1500);
//   };

//   document.addEventListener('DOMContentLoaded', runWithDelay);

//   // Watch for dynamic changes
//   const observer = new MutationObserver(() => {
//     hideLastThree();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();






















// document.addEventListener('DOMContentLoaded', function () {

//   const isTargetPage =
//     window.location.pathname.includes('/products/natural-deodorant') &&
//     window.location.search.includes('selection=refills');

//   if (!isTargetPage) return;

//   const toRemove = [1, 2, 3, 4, 9, 10, 11]; // 1-based

//   function removePswpThumbs() {
//     const allThumbs = document.querySelectorAll('.pswp__thumbs figure');
//     if (allThumbs.length > 0) {
//       toRemove.slice().sort((a, b) => b - a).forEach(num => {
//         const thumb = allThumbs[num - 1];
//         if (thumb) thumb.style.display = 'none';
//       });
//     }
//   }

//   // ✅ Watch for pswp__thumbs to get populated (happens on lightbox open)
//   const observer = new MutationObserver(() => {
//     removePswpThumbs();
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

// });
// // new

// document.addEventListener('DOMContentLoaded', function () {

//   const isTargetPage =
//     window.location.pathname.includes('/products/natural-deodorant') &&
//     window.location.search.includes('selection=refills');

//   if (!isTargetPage) return;

//   function hideFirstThumb() {
//     const firstThumb = document.querySelector('.product__thumbs__holder .product__thumb:first-child');
    
//     if (firstThumb) {
//       firstThumb.style.display = 'none';
//     }
//   }

//   // Run once
//   hideFirstThumb();

//   // Handle dynamic rendering (Shopify sliders)
//   const observer = new MutationObserver(hideFirstThumb);
//   observer.observe(document.body, { childList: true, subtree: true });

// });














// document.addEventListener('DOMContentLoaded', function () {
//   const isTargetPage = 
//     window.location.pathname.includes('/products/natural-deodorant') && 
//     window.location.search.includes('selection=refills');

//   if (!isTargetPage) return;

//   const slidesToRemove = [2, 3, 4, 9, 10, 11];

//   const observer = new MutationObserver(() => {
//     const allSlides = document.querySelectorAll('.product__slide');

//     if (allSlides.length >= 11) {
//       slidesToRemove.sort((a, b) => b - a).forEach(num => {
//         const slide = allSlides[num - 1];
//         if (slide) slide.remove();
//       });
//       observer.disconnect();
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });








// document.addEventListener("DOMContentLoaded", function () {
//   const params = new URLSearchParams(window.location.search);
//   if (params.get("selection") !== "refills") return;

//   // IDs TO KEEP AND SHOW (in order, max 4)
//   const keepIDs = [
//     "52539702739278",  // ✅ ACTIVE FIRST - Cedarwood
//     "52539706671438",  // Santal
//     "52539712110926",  // Cypress
//     "52539727020366"   // Unscented
//   ];

//   function applyGalleryFilter() {
//     const slides = document.querySelectorAll(".product__slide");
//     const thumbs = document.querySelectorAll(".product__thumb-item");

//     if (slides.length === 0) return;

//     // STEP 1: Hide ALL slides and thumbnails first
//     slides.forEach(s => {
//       s.classList.remove("media--active");
//       s.classList.add("media--hidden");
//       s.style.display = "none";
//     });
//     thumbs.forEach(t => {
//       t.style.display = "none";
//     });

//     // STEP 2: Show only keepIDs slides and thumbnails
//     keepIDs.forEach((id, index) => {
//       // Match slide by data-image-id OR data-media-id
//       slides.forEach(slide => {
//         const slideImageId = slide.getAttribute("data-image-id");
//         const slideMediaId = slide.getAttribute("data-media-id") || "";
//         const match = slideImageId === id || slideMediaId.includes(id);

//         if (match) {
//           slide.style.display = "";
//           if (index === 0) {
//             slide.classList.add("media--active");
//             slide.classList.remove("media--hidden");
//           } else {
//             slide.classList.remove("media--active");
//             slide.classList.add("media--hidden");
//           }
//         }
//       });

//       // Match thumbnail by data-image-id OR data-media-id
//       thumbs.forEach(thumb => {
//         const thumbImageId = thumb.getAttribute("data-image-id");
//         const thumbMediaId = thumb.getAttribute("data-media-id") || "";
//         const match = thumbImageId === id || thumbMediaId.includes(id);

//         if (match) {
//           thumb.style.display = "";
//           if (index === 0) {
//             thumb.classList.add("is-active");
//           } else {
//             thumb.classList.remove("is-active", "active");
//           }
//         }
//       });
//     });

//     // STEP 3: Fix slider scroll — remove hidden slides from DOM flow
//     // so the slider container doesn't have blank scroll space
//     const gallery = document.querySelector(".product__slides");
//     if (gallery) {
//       const hiddenSlides = gallery.querySelectorAll('.product__slide[style*="display: none"]');
//       hiddenSlides.forEach(s => s.remove());
//     }

//     // STEP 4: Fix thumbnail strip — remove hidden thumbs from DOM flow
//     const thumbStrip = document.querySelector(".product__thumbs, .product-thumbs, .product__thumb-list");
//     if (thumbStrip) {
//       const hiddenThumbs = thumbStrip.querySelectorAll('.product__thumb-item[style*="display: none"]');
//       hiddenThumbs.forEach(t => t.remove());
//     }
//   }

//   // Run immediately
//   applyGalleryFilter();

//   // Also run via MutationObserver in case slides load late
//   const observer = new MutationObserver(() => {
//     const slides = document.querySelectorAll(".product__slide");
//     if (slides.length >= 4) {
//       applyGalleryFilter();
//       observer.disconnect();
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });














/* Smit */
/*
 * Broadcast Theme — custom.js
 */

// ─────────────────────────────────────────────
// 1. CART BOX CLEANER
// Keeps storage box qty in sync with min(cases, refills)
// ─────────────────────────────────────────────
(function () {
  const BOX_ID     = 52648915239246;
  const CASE_IDS   = new Set([51074268365134, 51074268332366, 51074268397902]);
  const REFILL_IDS = new Set([51074269249870, 51074269217102, 51074269184334, 51074269282638]);
  const HDR        = { 'Content-Type': 'application/json' };
  const CART_URLS  = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartUrl(url) {
    return url && CART_URLS.some(u => url.includes(u));
  }

  async function sync() {
    try {
      const { items } = await fetch('/cart.js').then(r => r.json());
      let cases = 0, refills = 0, boxLine = null, boxQty = 0;

      items.forEach((item, i) => {
        if (CASE_IDS.has(item.variant_id))   cases   += item.quantity;
        if (REFILL_IDS.has(item.variant_id)) refills += item.quantity;
        if (item.variant_id === BOX_ID)      { boxLine = i + 1; boxQty = item.quantity; }
      });

      const need = Math.min(cases, refills);

      if (need === 0 && boxLine) {
        await post('/cart/change.js', { line: boxLine, quantity: 0 });
      } else if (boxLine && boxQty !== need) {
        await post('/cart/change.js', { line: boxLine, quantity: need });
      }
    } catch (e) {
      console.error('[BoxSync]', e);
    }
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: HDR, body: JSON.stringify(body) });
  }

  // Intercept fetch
  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;
    const res = await _fetch.apply(this, arguments);
    if (isCartUrl(url)) setTimeout(sync, 300);
    return res;
  };

  // Intercept XHR
  const _XHR = XMLHttpRequest;
  XMLHttpRequest = function () {
    const xhr = new _XHR();
    const _open = xhr.open;
    xhr.open = function (...a) { this._url = a[1]; return _open.apply(this, a); };
    xhr.addEventListener('load', function () {
      if (isCartUrl(this._url)) setTimeout(sync, 300);
    });
    return xhr;
  };
  XMLHttpRequest.prototype = _XHR.prototype;
})();


// ─────────────────────────────────────────────
// 2. THUMBNAIL CLEANER
// Removes specific thumb positions on page load
// ─────────────────────────────────────────────
(async function () {

  // Run only on these 2 products
  const isAllowedProduct =
    window.location.href.includes('/products/natural-deodorant-refills') ||
    window.location.href.includes('/products/natural-deodorant');

  if (!isAllowedProduct) return;

  // const REMOVE = [1, 2, 4, 5];

  const CONTAINERS = [
    '.product_thumbs',
    '.product-thumbs',
    '.product__thumbs',
    '.product-thumbs__list',
    '.thumbnails',
    '[data-product-thumbs]',
    '.product__media-list',
    '.product__thumbs-holder',
    '.media--thumbnails'
  ];

  const CHILDREN = [
    '.product_thumb',
    '.product-thumb',
    'li',
    'a',
    ':scope > *'
  ];

  function findContainer(timeout = 12000) {
    return new Promise(resolve => {
      const start = Date.now();

      (function poll() {

        for (const s of CONTAINERS) {
          const el = document.querySelector(s);
          if (el) return resolve(el);
        }

        for (const img of document.querySelectorAll('main img, .product img')) {
          const p = img.closest('div,section,ul');

          if (p?.querySelectorAll('img').length >= 3) {
            return resolve(p);
          }
        }

        if (Date.now() - start > timeout) {
          return resolve(null);
        }

        setTimeout(poll, 200);

      })();
    });
  }

  function findChildSel(container) {
    for (const s of CHILDREN) {
      try {
        if (container.querySelectorAll(s).length) return s;
      } catch (_) {}
    }

    return ':scope > *';
  }

  function removeNode(node) {
    try {
      const p = node.parentElement;

      node.remove();

      if (
        p?.children.length === 0 &&
        p.className?.includes('thumb')
      ) {
        p.remove();
      }

    } catch (_) {}
  }

  const container = await findContainer();

  if (!container) return;

  const sel = findChildSel(container);

  const nodes = Array.from(
    container.querySelectorAll(sel).length
      ? container.querySelectorAll(sel)
      : container.children
  );

  REMOVE
    .slice()
    .sort((a, b) => b - a)
    .forEach(pos => {
      if (nodes[pos - 1]) {
        removeNode(nodes[pos - 1]);
      }
    });

  Array.from(container.children).forEach(ch => {

    const r = ch.getBoundingClientRect();

    if (
      (r.width === 0 && r.height === 0) ||
      (
        !ch.querySelector('img') &&
        (ch.textContent || '').trim().length < 2
      )
    ) {
      try {
        ch.remove();
      } catch (_) {}
    }
  });

  Object.assign(container.style, {
    gap: '0',
    margin: '0',
    padding: '0',
    alignItems: 'flex-start'
  });

  Array.from(container.children).forEach(ch => {
    Object.assign(ch.style, {
      margin: '0',
      padding: '0',
      minHeight: '0',
      minWidth: '0'
    });
  });

  try {
    window.dispatchEvent(new Event('resize'));

    if (typeof window.Slideshow?.reinit === 'function') {
      window.Slideshow.reinit();
    }

    if (window.jQuery) {
      jQuery(window).trigger('resize');
    }

  } catch (_) {}

})();

// ─────────────────────────────────────────────
// 3. SCENT SLIDE SYNC (main product page)
// When a refill scent is added/removed in the
// starter pack selector, sync the product gallery
// to show that scent's image.
//
// Map: scent variant ID → thumbnail index (1-based)
// Adjust the map below to match your actual
// variant IDs and image positions.
// ─────────────────────────────────────────────
(function () {
  // Only run on product pages, skip refill-pdp (refills.js handles that)
  if (!window.location.pathname.includes('/products/')) return;
  if (document.body.classList.contains('template-product-refill-pdp')) return;

  // ── Configure: scent variant ID → thumb index (1-based) ──────────────────
  // Index 0 in thumbs array = generic/first image (shown on deselect)
  const VARIANT_THUMB_MAP = {
    '51074269184334': 5,
    '51074269217102': 4,
    '51074269249870': 6,
    '51074269282638': 7
  };
  // ─────────────────────────────────────────────────────────────────────────

  function getThumbs() {
    return Array.from(document.querySelectorAll(
      '.product__thumb a, .product__thumb__link, a.product_thumb, .product-thumb a, .product-thumbs a'
    )).filter(el => el.offsetParent !== null);
  }

  function safeClick(el) {
    if (!el) return;
    const a = el.closest('a') || el.querySelector('a') || el;
    setTimeout(() => a.click(), 10);
  }

  function getRow(btn) {
    return btn.closest('[data-variant-id]') ||
           btn.closest('[data-variant-id-row]') ||
           btn.closest('[data-variant]') ||
           btn.closest('.scent-row');
  }

  function getVariantId(row) {
    return row.getAttribute('data-variant-id') ||
           row.getAttribute('data-variant');
  }

  // Show the image for a given scent variant
  function showScentImage(variantId) {
    const idx = VARIANT_THUMB_MAP[String(variantId)];
    if (idx == null) return;
    const thumbs = getThumbs();
    if (thumbs[idx - 1]) safeClick(thumbs[idx - 1]);
  }

  // Show first (generic) image
  function showDefaultImage() {
    const thumbs = getThumbs();
    if (thumbs[0]) safeClick(thumbs[0]);
  }

  document.addEventListener('DOMContentLoaded', () => {

    // ── Click on big-plus (Add) → show scent image ──────────────────────────
    document.body.addEventListener('click', e => {
      const btn = e.target.closest('.big-plus');
      if (!btn) return;
      const row = getRow(btn);
      if (!row) return;
      const variantId = getVariantId(row);
      requestAnimationFrame(() => showScentImage(variantId));
    });

    // ── Click minus → if qty hits 0, show default image ────────────────────
    document.body.addEventListener('click', e => {
      const btn = e.target.closest('.minus-btn');
      if (!btn) return;
      const row = getRow(btn);
      if (!row) return;
      setTimeout(() => {
        const input = row.querySelector('.quantity-input');
        if (input && parseInt(input.value, 10) === 0) showDefaultImage();
      }, 80);
    });

    // ── Reset button → show default image ───────────────────────────────────
    document.addEventListener('click', e => {
      if (e.target.closest('#reset-selections')) showDefaultImage();
    });

    // ── Watch quantity inputs for external changes ───────────────────────────
    function watchRow(row) {
      const input = row.querySelector('.quantity-input');
      if (!input || input._watched) return;
      input._watched = true;
      const variantId = getVariantId(row);
      let last = input.value;
      new MutationObserver(() => {
        const val = parseInt(input.value, 10);
        if (val > 0 && last === '0') showScentImage(variantId);
        if (val === 0 && last !== '0') showDefaultImage();
        last = String(val);
      }).observe(input, { attributes: true, childList: true, characterData: true });
    }

    // Attach watchers to all existing scent rows
    document.querySelectorAll('.scent-row').forEach(watchRow);

    // Also watch for dynamically added scent rows
    new MutationObserver(() => {
      document.querySelectorAll('.scent-row').forEach(watchRow);
    }).observe(document.body, { childList: true, subtree: true });

  });
})();